import { useQuery } from "@tanstack/react-query";

import { useAppContext } from "./useAppContext";
import { useAttribute } from "./useAttribute";
import { useClient } from "./useClient";

export function useCart() {
	const client = useClient();

	const { reactQueryNoReloadOptions } = useAppContext();

	const selectedAttributeCode = useAttribute();

	const result = useQuery<eXpress.core.IShoppingCartInfo>({
		queryKey: ["use-cart", selectedAttributeCode],
		queryFn: () => {
			return client.getShoppingCartInfoAsync(selectedAttributeCode);
		},
		...reactQueryNoReloadOptions,
		retry: false,
	});

	return result.isSuccess ? result.data : undefined;
}
